/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Leading_Trailing_Spaces_LabelInputs */

const en_style_guide_manager_leading_trailing_spaces_label = /** @type {(inputs: Style_Guide_Manager_Leading_Trailing_Spaces_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leading & Trailing Spaces`)
};

const fr_style_guide_manager_leading_trailing_spaces_label = /** @type {(inputs: Style_Guide_Manager_Leading_Trailing_Spaces_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espaces de debut et de fin`)
};

const de_style_guide_manager_leading_trailing_spaces_label = /** @type {(inputs: Style_Guide_Manager_Leading_Trailing_Spaces_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorder- und Rückräume`)
};

const it_style_guide_manager_leading_trailing_spaces_label = /** @type {(inputs: Style_Guide_Manager_Leading_Trailing_Spaces_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spazi iniziali e finali`)
};

const ru_style_guide_manager_leading_trailing_spaces_label = /** @type {(inputs: Style_Guide_Manager_Leading_Trailing_Spaces_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ведущие и следующие зоны`)
};

const es_style_guide_manager_leading_trailing_spaces_label = /** @type {(inputs: Style_Guide_Manager_Leading_Trailing_Spaces_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espacios iniciales y finales`)
};

const zh_cn2_style_guide_manager_leading_trailing_spaces_label = /** @type {(inputs: Style_Guide_Manager_Leading_Trailing_Spaces_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`首尾空格`)
};

const ja_style_guide_manager_leading_trailing_spaces_label = /** @type {(inputs: Style_Guide_Manager_Leading_Trailing_Spaces_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`先頭と末尾のスペース`)
};

const hi_style_guide_manager_leading_trailing_spaces_label = /** @type {(inputs: Style_Guide_Manager_Leading_Trailing_Spaces_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अग्रणी और अनुगामी स्थान`)
};

const pt_pt2_style_guide_manager_leading_trailing_spaces_label = /** @type {(inputs: Style_Guide_Manager_Leading_Trailing_Spaces_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espaços de liderança e de seguimento`)
};

/**
* | output |
* | --- |
* | "Leading & Trailing Spaces" |
*
* @param {Style_Guide_Manager_Leading_Trailing_Spaces_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_leading_trailing_spaces_label = /** @type {((inputs?: Style_Guide_Manager_Leading_Trailing_Spaces_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Leading_Trailing_Spaces_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_leading_trailing_spaces_label(inputs)
	if (locale === "de") return de_style_guide_manager_leading_trailing_spaces_label(inputs)
	if (locale === "it") return it_style_guide_manager_leading_trailing_spaces_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_leading_trailing_spaces_label(inputs)
	if (locale === "es") return es_style_guide_manager_leading_trailing_spaces_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_leading_trailing_spaces_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_leading_trailing_spaces_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_leading_trailing_spaces_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_leading_trailing_spaces_label(inputs)
	return en_style_guide_manager_leading_trailing_spaces_label(inputs)
});